import { Delta } from '../yeni-design/primitives';
import { yuzdeDegisim } from './ozetHesaplari';

/**
 * Onceki doneme gore yuzde degisim hucresi — kartlardaki `Delta` rozetiyle AYNI bicim; degisim yoksa "—".
 * G2b/final (D-FE1 duzeltmesi): KanalBlok ve detay govdeleri (ortak.tsx) ayni hesabi (`yuzdeDegisim`) ayni bicimde
 * ciziyordu — TEK bilesen. Iki giris: hazir hesaplanmis `deger` (KanalBlok: `kanalTablosu` onceki pencere gelmeden
 * de null verir) ya da `bu`/`onceki` (detay govdeleri; onceki yok/0 ise "—"). Blok katmaninda durur: bloklar
 * `detay/`a bagimli olmasin; `detay/ortak.tsx` yeniden disa aktarir.
 */
export type DeltaHucreProps = { deger: number | null } | { bu: number; onceki: number | null };

export function DeltaHucre(p: DeltaHucreProps) {
  const d = 'deger' in p ? p.deger : yuzdeDegisim(p.bu, p.onceki);
  if (d === null) return <span className="text-ink-400">—</span>;
  return <Delta value={d} decimals={1} size="sm" />;
}
